import { Password, PasswordProps } from 'primereact/password';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type RHFPasswordProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    placeholder?: string;
    inputProps?: PasswordProps;
};

export const RHFPassword = ({ control, name, rules, placeholder, inputProps }: RHFPasswordProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <Password
                    id={field.name}
                    {...field}
                    ref={undefined}
                    inputRef={field.ref}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    placeholder={placeholder}
                    feedback={false}
                    toggleMask={true}
                    {...inputProps}
                />
            )}
        />
    );
};
